// @flow
import React from 'react';
import useSheet from 'app/jss';
import * as cssUtils from 'app/utils/cssUtils';
import { connect } from 'react-redux';
import colorUtils from 'color';
import { createFriendRequests } from 'app/actions/friendRequestActions';
import FriendIdentity from 'app/components/friends/common/FriendIdentity';
import t from 'app/utils/translate';
import Tappable from 'app/components/commons/Tappable';
import Icon from 'app/components/commons/Icon';
import FriendDisabledOverlay from 'app/components/friends/common/FriendDisabledOverlay';
import BouncyLoader from 'app/components/commons/BouncyLoader';
import FriendGroups from './groups/FriendGroups';
import FriendDetailsHeader from './FriendDetailsHeader';
import FriendDetailsPanel from './panels/FriendDetailsPanel';
import FriendDetailsContent from './FriendDetailsContent';

type Props = {
  searchFriend: User,
  onClick?: (id: number) => void,
  sendFriendRequest: () => void,
  classes: Object,
  groups: Array<FriendGroup>,
  currentGroup?: number | string,
  isSending: boolean,
};

type State = {};

class FriendMaybeDetails extends React.Component {
  props: Props;
  state: State = {};

  static defaultProps = {
    onClick: undefined,
    currentGroup: undefined,
  };

  sendFriendRequest = () => {
    const { searchFriend, sendFriendRequest, currentGroup } = this.props;
    sendFriendRequest([searchFriend.id], currentGroup);
  };

  render() {
    const { searchFriend, onClick, classes, groups, isSending } = this.props;
    return (
      <div className={classes.friendMaybeDetails}>
        <FriendDetailsHeader onClick={onClick}>
          <FriendIdentity friend={searchFriend} />
        </FriendDetailsHeader>
        <FriendDetailsPanel>
          {!isSending && (
            <Tappable onTap={this.sendFriendRequest} className={classes.sendRequest} key="send">
              <Icon type="icon-add-friend" />
              <span>{t('SEND A FRIEND REQUEST')}</span>
            </Tappable>
          )}
          {isSending && (
            <div className={classes.sending} key="sending">
              <div className={classes.loaderContainer}>
                <BouncyLoader scheme="dark" />
              </div>
            </div>
          )}
        </FriendDetailsPanel>
      </div>
    );
  }
}

function applyStyles(theme: Theme) {
  return {
    sending: {
      flexGrow: 1,
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
    },
    loaderContainer: {
      width: 40,
    },
    friendMaybeDetails: {
      display: 'flex',
      flexDirection: 'column',
      height: '100%',
      '-webkit-font-smoothing': 'antialiased',
    },
    sendRequest: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      flexGrow: 1,
      backgroundColor: theme.color.primary,
      color: theme.color.white,
      transition: 'background-color 0.2s, color 0.2s',
      borderBottom: {
        color: theme.color.basis6,
        width: 1,
        style: 'solid',
      },
      '& > *:not(:last-child)': {
        marginRight: 5,
      },
      ...cssUtils.hover({
        backgroundColor: colorUtils(theme.color.primary)
          .darken(0.1)
          .hex(),
        color: colorUtils(theme.color.white)
          .darken(0.2)
          .hex(),
      }),
    },
  };
}

function mapStateToProps(state: GlobalState) {
  return {
    groups: state.friendGroups.groups,
    currentGroup: state.friendGroups.currentGroup,
    isSending: state.friendRequests.isCreatingFriendRequests.length > 0,
  };
}

const actions = {
  sendFriendRequest: createFriendRequests,
};

export default useSheet(applyStyles)(connect(mapStateToProps, actions)(FriendMaybeDetails));
